import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks, siteInfo } from '@/mocks/homeData';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="container-wide flex items-center justify-between h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className={`text-lg md:text-xl font-bold font-heading transition-colors duration-300 ${
            isScrolled ? 'text-primary-600' : 'text-background-50'
          }`}>
            {siteInfo.name}
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap ${
                  isActive
                    ? isScrolled
                      ? 'text-primary-600 bg-primary-50'
                      : 'text-background-50 bg-background-50/20'
                    : isScrolled
                      ? 'text-foreground-600 hover:text-primary-600 hover:bg-primary-50/50'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/15'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        <div className="hidden md:flex items-center gap-2">
          <a
            href="tel:4008886688"
            className={`flex items-center gap-1.5 text-sm font-medium whitespace-nowrap transition-colors duration-300 ${
              isScrolled ? 'text-primary-600' : 'text-background-50'
            }`}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-sm"></i>
            </span>
            {siteInfo.phone}
          </a>
        </div>

        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
            isScrolled ? 'text-foreground-700' : 'text-background-50'
          }`}
          aria-label="Toggle menu"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className={`text-lg ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </span>
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="container-wide py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'text-primary-600 bg-primary-50'
                      : 'text-foreground-600 hover:text-primary-600 hover:bg-primary-50/50'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <a
              href="tel:4008886688"
              className="px-4 py-2.5 rounded-lg text-sm font-medium text-primary-600 flex items-center gap-2"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-sm"></i>
              </span>
              {siteInfo.phone}
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}